export default __webpack_public_path__ + "static/strategy_manager_img-4bcf6d3a8f0e846c3dc4b6bad803365e.png";